export const SET_SNACKBAR_DATA = "SET_SNACKBAR_DATA";
